import { spreadOf, tableSpread } from '../../engine/assets/teamEdits';
import { sheetOnTeam } from '../../engine/roster/team';

/**
 * A kill-team change saved on one sheet at the table, carried to the rest of its team (plan modes-rework): the GM's
 * save only (a player's edit stays on his own sheet). What each sheet becomes is `tableSpread`'s; this writes it - each
 * roster copy through its sheet write, each other session character through the library.
 *
 * @param {{ roster: { id: string, sheet: object }[], library: { characters: object[], saveCharacter(c: object): void },
 *   updateCombatantSheet(id: string, edit: (sheet: object) => object): void }} table
 * @param {object | null} before - the sheet as the editor opened it
 * @param {object} saved - the sheet as it was saved
 */
export function spreadAtTable(table, before, saved) {
  const spread = spreadOf(before?.team, saved.team);
  if (!spread) return;
  const plan = tableSpread(spread, saved.id, table.roster, table.library.characters);
  plan.roster.forEach(({ id, team }) => table.updateCombatantSheet(id, (sheet) => sheetOnTeam(sheet, team)));
  plan.library.forEach((ch) => table.library.saveCharacter(ch));
}
